import React from 'react';
import { motion, useScroll, useSpring } from 'framer-motion';

/**
 * Schmaler Fortschrittsbalken am oberen Bildschirmrand,
 * der den Scroll-Fortschritt der Seite visualisiert.
 */
const ScrollProgress = () => {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 120,
    damping: 24,
    restDelta: 0.001,
  });

  return (
    <motion.div
      style={{ scaleX }}
      className="fixed top-0 left-0 right-0 h-0.5 z-[60] origin-left
                 bg-gradient-to-r from-wood-600 via-gold-500 to-wood-600
                 dark:from-gold-400 dark:via-gold-300 dark:to-gold-400
                 pointer-events-none"
      aria-hidden="true"
    />
  );
};

export default ScrollProgress;
